import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateStatus } from '../core';
import { getServiceCategories } from '../new/category';
const useServiceCategories = _ref => {
  let {
    type,
    providerId
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.categories.services);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && (request.type !== type || request.providerId !== providerId)) {
      dispatch(getServiceCategories(type, providerId));
    }
  }, [data, dispatch, providerId, request, status, type]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useServiceCategories;